import script from "./ingredient-item.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredient-item.vue?vue&type=script&setup=true&lang=js"

import "./ingredient-item.vue?vue&type=style&index=0&id=3c7a76df&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7a76df"]])

export default __exports__